import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UploadImageComponent } from './upload-image/upload-image.component'
import { NzUploadModule } from 'ng-zorro-antd/upload'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { vssProviders } from '../../vss.providers'
import { VssDragDropUploadFileComponent } from './vss-drag-drop-upload-file/vss-drag-drop-upload-file.component'
import { VssUiDirectivesModule } from '../directives/vss-ui-directives.module'
import { NzFormModule } from 'ng-zorro-antd/form'
import { NzProgressModule } from 'ng-zorro-antd/progress'
import { VssDragDropUploadFileComponentV2 } from './vss-drag-drop-upload-file-v2/vss-drag-drop-upload-file-v2.component'
import { NzToolTipModule } from 'ng-zorro-antd/tooltip'
import { ImportFileComponent } from './import-file/import-file.component'
import { VssDragDropUploadFileComponentV3 } from './vss-drag-drop-upload-file-v3/vss-drag-drop-upload-file-v3.component'
import { TranslateModule } from '@ngx-translate/core'

const components = [
  UploadImageComponent,
  VssDragDropUploadFileComponent,
  VssDragDropUploadFileComponentV2,
  ImportFileComponent,
  VssDragDropUploadFileComponentV3
]


@NgModule({
  declarations: [
    ...components
  ],
  exports: [
    ...components
  ],
  imports: [
    CommonModule,
    NzUploadModule,
    NzIconModule,
    VssUiDirectivesModule,
    NzFormModule,
    NzProgressModule,
    NzToolTipModule,
    TranslateModule
  ],
  providers: [...vssProviders]
})
export class UploadModule { }
